import { render, staticRenderFns } from "./ContributorsList.vue?vue&type=template&id=625b80fc"
import script from "./ContributorsList.vue?vue&type=script&lang=js"
export * from "./ContributorsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports